import Vue from 'vue'
import store from '@/store'
let SolutionTableFatherDlgConstructor = Vue.extend(require('./main.vue'))

let instance

var solutionTableFatherDlg = function (options) {
  options = options || {}
  if (!instance) {
    instance = new SolutionTableFatherDlgConstructor({
      data: options,
      store: store
    })
    instance.vm = instance.$mount()
    document.body.appendChild(instance.vm.$el)
  }

  // instance.vm.loadData()
  console.log('options=', options)
  instance.vm.tmguid = options.tmguid
  instance.vm.show = true
  return instance.vm
}

export default solutionTableFatherDlg



// WEBPACK FOOTER //
// ./src/components/solutionTableFatherDlg/src/main.js